var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bg-light-grey pb-0 pt-0"},[_c('Header'),_c('section',{staticClass:"user_section module_user_section"},[_c('div',{staticClass:"page-container bg-light-grey",attrs:{"id":"page-container"}},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"container"},[_c('router-view')],1)])])]),_c('Footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }